<template>
  <div class="text-white">
    <div class="text-white">
      <h1 class="text-2xl px-3 font-semibold">Группировать в зоны</h1>
    </div>
    <div class="my-4 px-3">
      <div class="mr-4 mb-2">Выбранные районы</div>
      <div
        v-if="district.length > 0"
        class="max-w-[300px] flex flex-wrap gap-2"
      >
        <label
          v-for="(districts, index) in district"
          :key="index"
          class="border-[#3a383899] bg-[#3a383899] px-3 py-1 rounded-md text-sm whitespace-nowrap"
        >
          {{ districts.name }}
        </label>
      </div>
    </div>
    <div class="my-4 px-3 flex items-center justify-between">
      <label class="mr-5">Зона</label>
      <div class="w-[270px]">
        <customSelect
          :options="zones"
          v-model="group_id"
          label="name"
          value-key="id"
          :search="true"
        ></customSelect>
      </div>
    </div>
    <button class="buttonCustom ml-[66px]" @click="openModal()">
      Редактор зон
    </button>
    <div class="flex justify-between my-4 px-3">
      <button
        class="bg-white text-black rounded-sm mr-2 p-1 cursor-pointer"
        @click="close()"
      >
        Отмена
      </button>
      <button
        class="buttonCustom"
        :disabled="isActive"
        :class="isActive ? 'disabled' : ''"
        @click="editZone()"
      >
        Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import customSelect from "@/components/custom/customSelect/index.vue";
export default {
  props: ["village_id", "zona", "statusZone"],
  components: {
    customSelect,
  },
  data() {
    return {
      zones: [],
      district: [],
      isActive: true,
      zoneId: [],
      group_id: "",
    };
  },
  watch: {
    zona(newValue) {
      if (!newValue) {
        this.zoneId = [];
        return;
      }
      this.zoneId = newValue;
      this.getZones();
      this.district = [];
      this.isActive = true;
      this.zoneId.forEach((id) => {
        this.$http
          .get(`v1/polygons/child/${id}`)
          .then((res) => {
            this.district.push(res.data);
            this.group_id = res.data.group_id;
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.isActive = false;
          });
      });
    },
    village_id(newValue) {
      if (newValue) {
        this.getZones();
      }
    },
    statusZone(value) {
      if (!value) {
        if (this.zoneId.length > 0) {
          this.isActive = false;
        } else {
          this.isActive = true;
        }
      } else {
        this.isActive = true;
      }
    },
  },
  methods: {
    getZones() {
      this.$http.get(`v1/polygons/${this.village_id}/zones`).then((res) => {
        this.zones = res.data;
      });
    },
    openModal() {
      this.isActive = true;
      this.$emit("zoneStatus");
    },
    addZone() {
      let postData = {
        name: this.name,
        village_id: this.village_id,
      };
      this.$http
        .post("addresses/zones", postData)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    close() {
      (this.zones = []), (this.district = []), (this.isActive = true);
      this.$emit("close");
    },
    editZone() {
      this.isActive = true;
      this.$http
        .put(`v1/polygons/zone/${this.group_id}/childgroup`, {
          zones: this.zoneId,
        })
        .then(() => {
          this.$toast.open({
            message: "Изменено зона",
            type: "success",
            position: "top-right",
          });
          this.close();
        })
        .catch((error) => {
          this.$toast.open({
            message: `${error}`,
            type: "error",
            position: "top-right",
          });
        })
        .finally(() => {
          this.isActive = false;
        });
    },
  },
};
</script>

<style scoped>
.buttonCustom {
  @apply border-[1px] border-white bg-white rounded-[3px] text-black p-1;
}
.disabled {
  @apply bg-black text-white border-black;
}
</style>
